/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Refresh
 */
export interface Refresh {
  /**
   *
   */
  refresh: string;
  /**
   *
   */
  readonly access?: string;
}

/**
 * Check if a given object implements the Refresh interface.
 */
export function instanceOfRefresh(value: object): value is Refresh {
  if (!("refresh" in value) || value["refresh"] === undefined) return false;
  return true;
}

export function RefreshFromJSON(json: any): Refresh {
  return RefreshFromJSONTyped(json, false);
}

export function RefreshFromJSONTyped(json: any, ignoreDiscriminator: boolean): Refresh {
  if (json == null) {
    return json;
  }
  return {
    refresh: json["refresh"],
    access: json["access"] == null ? undefined : json["access"],
  };
}

export function RefreshToJSON(json: any): Refresh {
  return RefreshToJSONTyped(json, false);
}

export function RefreshToJSONTyped(
  value?: Omit<Refresh, "access"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    refresh: value["refresh"],
  };
}
